export default __webpack_public_path__ + "static/media/party-horn-solid.51880aec.svg";